export const footerEN = {
  productCenter: "Product Center",
  contectUs: "Contact Us",
  business: "Business",
  media: "Media",
  hr: "HR",
  address1:
    "12F, Block B, Tonghe International Building, No.477 Zhengli Road, Yangpu District, Shanghai",
  address2:
    "2F, West of Qihang Building, National University Science and Technology Park, 777 Zhonggong West Road, Zhenhai District, Ningbo City",
  followUs: "Follow Us",
  simulationWorld: "Follow the Future of Precise Simulation",
};
export const footerCN = {
  productCenter: "产品中心",
  contectUs: "联系我们",
  business: "业务合作",
  media: "媒体沟通",
  hr: "人才招聘",
  address1: "上海市杨浦区政立路477号同和国际大厦B座12F",
  address2: "浙江省宁波市镇海区庄市街道中官西路777号宁波市国家大学科技园启航楼2F西",
  followUs: "关注我们",
  simulationWorld: "关注精准仿真的未来",
};
